// extracted by mini-css-extract-plugin
export default {"link":"FB-z","disabled":"GB-z"};